import styled from 'styled-components';

export const BannerWrapper = styled.div`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
`;

export const BannerContentWrapper = styled.div`
  width: 100%;
  max-width: 1200px;
  padding: 16px;
  margin: 0 auto;
`;

export const BannerAlert = styled.div`
  display: flex;
  padding: 12px 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 12px;
  align-self: stretch;
  border-radius: 16px;
  border: 1px solid ${({ theme }) => theme.colors.orange3};
  background: ${({ theme }) => theme.colors.orange1};

  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }
`;

export const BannerTextContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  flex: 1;
`;

export const BannerTitle = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  align-self: stretch;
  color: ${({ theme }) => theme.colors.black9};
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const BannerDescription = styled.div`
  display: flex;
  padding-left: 32px;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  color: ${({ theme }) => theme.colors.black9};
  font-family: ${({ theme }) => theme.fontFamily.primary};
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;
